export { HistoryRecordDetails } from './HistoryRecordDetails'
